import {BaseAttribute} from "@/pages/AppPages/Events/attribute";
import { required } from "vuelidate/lib/validators";

export const OWNER_TYPES = {
    1: 'Владельцу',
    2: 'Новому владельцу'
}

export class OwnerEventAttributes extends BaseAttribute {

    constructor(initObjectParams) {
        super(initObjectParams)
        this.actNumber = null;
        this.actDate = null;
        this.ownerType = 1;
        this.ownerName = null; // Лицо, принявшее животное
        this.address = null;
        this.addressHumanReadable = null;
        this.addressObject = {};
        this.comment = null;
        this.ownerTypeText = null;

        if (initObjectParams && initObjectParams['actDate']) {
            this.actDate = initObjectParams['actDate']
        }
    }

    static get modelName() {
        return 'DisposalEvent'
    }

    static get validations() {
        return {
            actNumber: {},
            actDate: {},
            ownerType: { required },
            ownerName: {},
            address: {},
            ownerRepresentative: {},
            comment: {},
        }
    }

    static get validationFieldLabels() {
        return {
            actNumber: 'Акт',
            actDate: 'Дата составления',
            ownerType: 'Тип',
            ownerName: 'Лицо, принявшее животное',
            address: 'Адрес лица, принявшего животное',
            comment: 'Комментарий'
        }
    }

    static get mapping() {
        return {}
    }

    static get label() {
        return ''
    }

    static get newLabel() {
        return ''
    }

    objectLabel() {
        return ''
    }

    applyData(data) {
        this.actNumber = data['actNumber'];
        this.actDate = data['actDate'];
        this.ownerType = data['ownerType'];
        this.ownerName = data['ownerName'];
        this.ownerTypeText = OWNER_TYPES[this.ownerType];
        this.address = data['address'];
        this.addressObject = data['address_object'];
        this.ownerRepresentative = data['ownerRepresentative'];
        this.comment = data['comment']
    }

}